import {useMediaQuery} from "@mui/material";

import {UserAgentUtils} from "utils/useragent";

// Mobile mode: a phone/tablet device (user agent), or any window under the md
// breakpoint — the media query follows live resizes where the user agent cannot.
function useIsMobile() {
    const isNarrowScreen = useMediaQuery((theme) => theme.breakpoints.down('md'), {noSsr: true});

    return isNarrowScreen || UserAgentUtils.isMobileOrTablet();
}

export default useIsMobile;
